import { html, nothing } from '@arr2019/app-libs';
import { LOCALES_NAME } from '../../../lib/config.js';
import { isEventClick, isKeyEnterOrKeySpace } from 'a11y-key-conjurer';
export function languageSelector(props) {
  const {
    currentLocale,
    setCurrentLocale,
    showLanguagesList,
    setShowLanguagesList
  } = props;

  function handleClose() {
    setShowLanguagesList(!showLanguagesList);
    document.querySelector('[aria-controls="language-selector"]').focus();
  }

  function handleList(ev) {
    if (isEventClick(ev) || isKeyEnterOrKeySpace(ev)) {
      ev.preventDefault();
      handleClose();
    }
  }

  return html`
    <div class="relative">
      <div
        class="link-text--icon"
        role="button"
        tabindex="0"
        @click="${handleList}"
        @keydown="${handleList}"
        aria-controls="language-selector"
        aria-expanded="${String(showLanguagesList)}"
      >
        <i class="icon icon--languages"></i>
        ${LOCALES_NAME[currentLocale]}
        <i
          class="ml-1 icon ${showLanguagesList ? 'icon--fold' : 'icon--unfold'}"
        ></i>
      </div>
      ${showLanguagesList
        ? html`
            <ul id="languages-list" class="absolute top-full right-0 pr-5">
              ${Object.keys(LOCALES_NAME).map(item => {
                function fnHandleLanguage(ev) {
                  if (isEventClick(ev) || isKeyEnterOrKeySpace(ev)) {
                    ev.preventDefault();
                    setCurrentLocale(item);
                    document.querySelector('html').setAttribute('lang', item);
                    handleClose();
                  }
                }
                return item !== currentLocale
                  ? html`
                      <li>
                        <span
                          class="link-text"
                          role="button"
                          tabindex="0"
                          @click="${fnHandleLanguage}"
                          @keydown="${fnHandleLanguage}"
                        >
                          ${LOCALES_NAME[item]}
                        </span>
                      </li>
                    `
                  : nothing;
              })}
            </ul>
          `
        : nothing}
    </div>
  `;
}
